import styled from 'styled-components';
import colors from 'pubweb-react-components/dist/styles/colors';
import variables from '../../variables';

const QuizFormStyles = styled.div`
    background-color: #FFFFFF;
    width: 100%;

    h4 {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: -0.2px;
        line-height: 1.3;
        width: auto;
        margin-bottom: 0px;
        margin-left: 30px;
        margin-top: 30px;
        padding: 0 30px;
    }

    .legal-footer .body-copy-component {
        font-size: 12px;
        line-height: 1.4;
        margin-top: 30px;
        padding: 0 30px 30px;

        a:link, a:visited, a:hover, a:active {
            color: ${colors.grayscaleCoolGray08};
            text-decoration: underline;
        }
    }

    @media screen and (min-width: ${variables.desktop_breakpoint_width}px) {

        .legal-footer .body-copy-component {
            width: 390px
        }
    }
    @media screen and (min-width: ${variables.desktop_max_width}px){
        max-width: 20vw;
        
    }
`;

export default QuizFormStyles;